import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default {
    init() {
        // JavaScript to be fired on the home page
        // Headline word animation
        // Animate button text on hover
        gsap.registerPlugin(SplitText);

        let headline = document.querySelector('.masthead__title');
        let subheadline = document.querySelector('.masthead__subtitle');
        if (headline) {
            let splitText = new SplitText(headline, {
                type: 'words',
            });
            let words = splitText.words;
            let tl = gsap.timeline();

            // Animate words up
            tl.from(words, {
                duration: 1,
                y: 50,
                opacity: 0,
                stagger: 0.07,
            });

            if (subheadline) {
                tl.from(subheadline, {
                    duration: 0.5,
                    y: 50,
                    opacity: 0,
                }, '-=0.75');
            }
        }

        // Horizontal scroll animation
        gsap.registerPlugin(ScrollTrigger);
        let scrollSection = document.querySelector('.horizontal-scroll .e-con-inner');

        // Scroll amount equals the width of the scroll section minus the width of the visible area
        function getScrollAmount() {
            let scrollSectionWidth = scrollSection.offsetWidth; // Full width of scroll section
            return -(scrollSectionWidth - window.innerWidth);
        }

        gsap.to(scrollSection, {
            x: getScrollAmount(),
            scrollTrigger: {
                trigger: scrollSection,
                start: 'center center',
                end: () => `${getScrollAmount() * -1}`,
                pin: true,
                scrub: true,
                // markers: true,
                anticipatePin: 1,
                pinSpacing: true,
                invalidateOnRefresh: true,
            },
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js